import {usePublicPropertiesStore} from '../store/publicProperties';

export const getPublicProperty = <Bool extends boolean = false>(
	key: string,
	asBoolean?: Bool,
) => usePublicPropertiesStore.getState().get<Bool>(key, asBoolean);

export default getPublicProperty;
